// extracted by mini-css-extract-plugin
export default {"OfferCollapseWrapper":"Select_OfferCollapseWrapper__h4J+c","Spin":"Select_Spin__MrhUT"};